import { type VariantProps, cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';
import { ButtonOrLink } from '../button-or-link';
import { useTranslation } from 'react-i18next';

import type { JSX } from 'react';

export interface UserMenuProps
    extends CommonProps,
        VariantProps<typeof UserMenuStyles> {
    logout: () => void;
    accountLabel: string;
    logoutLabel: string;
}

export const UserMenuStyles = cva(
    'absolute flex flex-col -translate-x-1/2 text-center z-1 top-full left-1/2 rounded-md bg-gray-500'
);

export const UserMenu = ({
    className,
    logout,
    accountLabel,
    logoutLabel,
    testId = 'user-menu',
    ...props
}: UserMenuProps): JSX.Element => {
    const { i18n } = useTranslation();

    return (
        <div
            className={twMerge(UserMenuStyles({ className }))}
            {...props}
            data-testid={testId}
        >
            <ButtonOrLink
                className="px-2 py-3 text-lg text-white/50 hover:text-white/100 md:px-8"
                href={`/${i18n.language}/account/`}
            >
                {accountLabel}
            </ButtonOrLink>
            <ButtonOrLink
                className="whitespace-nowrap px-2 py-3 text-lg text-white/50 hover:text-white/100 md:px-8"
                onClick={logout}
            >
                {logoutLabel}
            </ButtonOrLink>
        </div>
    );
};
